// Mock implementation to avoid dependencies
export const generatePdf = async (elementId: string, fileName: string) => {
  console.warn('PDF generation is not supported in this environment (missing html2canvas/jspdf).');
};
